export function applySurveyTextRules(text?: string | null): string | null | undefined {
  if (text) {
    let value = typeof text === 'string' ? text : String(text);

    value = removeBackSlashesBeforeQuotes(value);
    value = convertNonBreakingSpacesToRegularSpaces(value);
    value = preventEmptyParagraphTagsFromCollapsing(value);
    value = enforceParagraphWrapping(value);
    value = replaceNewLinesWithBr(value);

    const containsLinks = value.includes('{LINK');
    if (containsLinks) {
      value = createUrlOrEmailLinks(value, /{LINK\|([^|]*)\|([^|}]*)}/g, 'link');
    }

    const containsMailToLinks = value.includes('{MAILTO');
    if (containsMailToLinks) {
      value = createUrlOrEmailLinks(value, /{MAILTO\|([^|]*)\|([^|}]*)}/g, 'email');
    }
    return value;
  }
  return text;
}

function convertNonBreakingSpacesToRegularSpaces(text: string): string {
  return text.replaceAll('&nbsp;', ' ');
}

function removeBackSlashesBeforeQuotes(text: string): string {
  return text.replaceAll(String.raw`\"`, '"');
}

function preventEmptyParagraphTagsFromCollapsing(text: string): string {
  return text.replaceAll(/<p([^>]*)>\s*<\/p>/gi, '<p$1>&nbsp;</p>');
}

function enforceParagraphWrapping(text: string): string {
  let value = text.replaceAll(
    /(<p[^>]*style=["'])/gi,
    '$1overflow-wrap: break-word; word-break: break-word; '
  );
  value = value.replaceAll(
    /<p(?![^>]*style=)([^>]*)>/gi,
    '<p style="overflow-wrap: break-word; word-break: break-word;"$1>'
  );

  return value;
}

function replaceNewLinesWithBr(text: string): string {
  return text.replaceAll('\n', '<br/>');
}

function createUrlOrEmailLinks(text: string, regex: RegExp, key: 'link' | 'email'): string {
  let index = 0;
  let textAfter = '';
  let result: RegExpExecArray | null;
  // eslint-disable-next-line no-cond-assign
  while ((result = regex.exec(text))) {
    const msg = result[1];

    let url: string;
    if (key === 'email') {
      url = `mailto:${result[2]}`;
    } else if (result[2].includes('://')) {
      url = `https://${result[2].split('://')[1]}`;
    } else {
      url = `https://${result[2]}`;
    }

    if (index === 0) {
      textAfter = text.replace(
        result[0],
        `<a href='${url}'${key === 'link' ? " target='_blank'" : ''}>${msg}</a>`
      );
    } else {
      textAfter = textAfter.replace(
        result[0],
        `<a href='${url}'${key === 'link' ? " target='_blank'" : ''}>${msg}</a>`
      );
    }
    index++;
  }
  return textAfter;
}
